import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-arrow-right",
  "use": "icon-ib-arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-arrow-right\">\r\n    <path d=\"M311.168 140.501333a42.666667 42.666667 0 0 1 60.330667 0l341.333333 341.333334a42.666667 42.666667 0 0 1 0 60.330666l-341.333333 341.333334a42.666667 42.666667 0 0 1-60.330667-60.330667L622.336 512 311.168 200.832a42.666667 42.666667 0 0 1 0-60.330667z\" p-id=\"4782\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol